import { useRouter } from 'next/router';
import Modal from '../../../../../new-components/mobile/Modal';
import Button from '../../../../../new-components/ui/Button';
import { useTranslation } from 'next-i18next';

interface PropTypes {
  isOpen: boolean;
  closeFn: () => void;
}

const PlanLoadModal = ({ isOpen, closeFn }: PropTypes) => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  return (
    <Modal withCloseBtn={false} isOpen={isOpen} closeFn={closeFn}>
      <div className="plan-info-alert">
        <div className="plan-info">
          <span className="plan-info-title">
            {locale === 'en'
              ? t('back_loaded') + ' ' + t('payment_plan')
              : t('back_loaded')}
          </span>

          <span className="plan-info-description">{t('back_loaded_info')}</span>
        </div>

        <Button
          backgroundColor="#1E4164"
          color="white"
          fontSize="14px"
          padding="8px"
          text={t('got_it')}
          border="transparent"
          onClick={closeFn}
        />
      </div>
    </Modal>
  );
};

export default PlanLoadModal;
